import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import BackgroundImage from "@components/BackgroundImageCst";
import Table from "@components/Table";
import HeroCst from "@components/HeroCst";
import Breadcrumb from "@components/Breadcrumb";
import { useParams } from "react-router-dom";
import {
  useDeleteDetail,
  useFetchDetail,
  usePutDetail,
} from "@hooks/useFetchDetail";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { Category } from "src/interfaces/Category";
import ButtonBackPage from "@components/ButtonBackPage";
import AnimationFadeIn from "@components/AnimationFadeIn";
import useSWRMutation from "swr/mutation";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";

const ViewElements: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["categories-page", "modal"]);
  const { id = "1", idInitiative, idCategory } = useParams();
  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { columns, dataTable, actionsTopToolbar, actionForRow, mutate } =
    useFetchTable<any[]>(
      `${ServicesURL.categoriesSorting
        .replace(":idCorporate", id)
        .replace(":idInitiative", idInitiative || "")}/${idCategory}`,
      PagesID["corporate.initiative.categories.view-elements"],
    );

  const { dataDetail } = useFetchDetail(
    ServicesURL.categories + `/${idInitiative}/categories`,
    idCategory || "",
    PagesID["corporate.initiative.categories"],
  );

  const { trigger: triggerPutCategory } = useSWRMutation(
    `${ServicesURL.putCategoriesSorting
      .replace(":idInitiative", idInitiative || "")
      .replace(":idCategory", idCategory || "")}`, //!! (SOLO DI ESEMPIO) MODIFICARE SERVICE URL CON QUELLO INSERITO NEL FILE DI CONFIG
    (url: string, { arg }: { arg: { idLO: string; order: string } }) => {
      return fetcher<any>(
        `${url.replace(":idLO", arg.idLO)}/${arg.order}`,
        MethodType.PUT,
      ); //SE NECESSARIO CAMBIARE METHODTYPE o AGGIUNGERE QUERY ALL'URL
    },
  );

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-corp-initiatives.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={`${t("sorting.hero-title")}${dataDetail?.name ? ` - ${dataDetail?.name}` : ""}`}
          description={t("hero-description")}
        />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          <Table
            id={PagesID["corporate.initiative.categories.view-elements"]}
            data={dataTable?.loData}
            columns={columns || []}
            configurationTopToolbar={actionsTopToolbar}
            initialState={{
              sorting: [
                {
                  id: "order", //sort by order by default on page load
                  desc: false,
                },
              ],
            }}
            configurationActionForRow={actionForRow}
            totalPages={dataTable?.metadata?.total_elements}
            enableRowDrag={true}
            onDragChange={async (
              draggingElements: any,
              hoveredElements: any,
            ) => {
              try {
                await triggerPutCategory({
                  idLO: draggingElements["id"],
                  order: hoveredElements["order"] || "",
                });
                mutate && (await mutate());
              } catch (error) {
                console.error(error);
              }
            }}
          />
        </Box>
      </Container>
      {/* <ModalConfirmsCst
        open={!!open}
        title={t("delete-item", { ns: "modal" })}
        description={t("confirm-delete", { ns: "modal" })}
        onCallBackClosed={() => {
          setOpen(false);
          setOpenToast(undefined);
        }}
        routeToSamePage={true}
        onActionConfirmed={() => handleDelete()}
        status={openToast}
      /> */}
    </AnimationFadeIn>
  );
};

export default ViewElements;
